import { isAdmin, isAthlete, isCoach, isGuardian, isStaff } from "../utils/auth";
import { formatRoleLabel } from "./roleLabels";

export function gettingStartedRoleLabel(): string {
    if (isAdmin()) {
        return formatRoleLabel("ADMINISTRATOR");
    }
    if (isStaff()) {
        return formatRoleLabel("STAFF");
    }
    if (isCoach()) {
        return formatRoleLabel("COACH");
    }
    if (isGuardian()) {
        return formatRoleLabel("GUARDIAN");
    }
    if (isAthlete()) {
        return formatRoleLabel("ATHLETE");
    }
    return "Member";
}
